import {Button, ButtonSizes, ButtonVariants} from '@wandb/weave/components';
import React from 'react';

import {type MediaBrowserPanelConfig} from '../../../../PanelMediaBrowser/common';
import {useMediaSettingsState} from '../contexts/MediaSettingsContextProvider';

export const SettingTitle: React.FC<{
  title: string;
  id?: string;
  description?: string;
  tooltip?: React.ReactElement | string;
  unsetConfigField?: () => void;
  configField?: keyof MediaBrowserPanelConfig;
  /** Use this for complex dirty checks that are not just a single config field. Use the default dirty check otherwise. */
  isDirty?: boolean;
  isSubSetting?: boolean;
  cta?: React.ReactNode | undefined;
}> = ({
  title,
  id,
  description,
  tooltip,
  unsetConfigField,
  configField,
  isSubSetting,
  cta,
  isDirty,
}) => {
  const {configWithoutDefaults} = useMediaSettingsState();
  // A stored `null` is the explicit-clear sentinel and counts as set at this
  // level; only `undefined` is unset.
  const canReset =
    isDirty ??
    (configField != null && configWithoutDefaults[configField] !== undefined);
  return (
    <div className="mb-2 flex flex-col">
      <div className="flex items-center justify-between">
        <div className="flex gap-4" id={id}>
          <div
            className={`pb-2 ${isSubSetting ? 'font-medium' : 'font-semibold'}`}>
            {title}
            {cta}
          </div>
          {tooltip && (
            <Button
              size="small"
              variant="ghost"
              icon="info"
              tooltipProps={{className: 'max-w-[20rem]'}}
              tooltip={tooltip}
            />
          )}
        </div>
        {canReset && unsetConfigField && (
          <Button
            aria-label="Reset to parent"
            icon="randomize-reset-reload"
            onClick={unsetConfigField}
            size={ButtonSizes.Medium}
            tooltip="Reset to parent"
            variant={ButtonVariants.Ghost}
            data-test={`reset-to-parent-${configField}`}
          />
        )}
      </div>
      {description && (
        <div className="pt-2 text-sm text-wb-text-secondary">{description}</div>
      )}
    </div>
  );
};
